(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tide-catch-finder"] && !Shopify.designMode) return;
  try {
    
  const initTideFinders = (root = document) => {
    root.querySelectorAll('[data-tide-finder]').forEach((finder) => {
      if (finder.dataset.ready === 'true') return;
      finder.dataset.ready = 'true';
      const tabs = [...finder.querySelectorAll('[data-tide-tab]')];
      const panels = [...finder.querySelectorAll('[data-tide-panel]')];
      const activate = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          tabs[next].focus();
          activate(tabs[next]);
        });
      });
    });
  };
  initTideFinders();
  document.addEventListener('shopify:section:load', (event) => initTideFinders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsukiji-auction"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-board]').forEach((board) => {
    const form = board.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    form.addEventListener('submit', () => {
      board.classList.add('is-sold');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsukiji-fish-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const parts = document.querySelectorAll('[data-fish-part]');
    parts.forEach((part) => {
      part.addEventListener('click', () => {
        parts.forEach((p) => p.classList.remove('is-active'));
        part.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsukiji-noren"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-noren]');
    if (!root) return;
    const tabs = root.querySelectorAll('[data-noren-tab]');
    const panels = root.querySelectorAll('[data-noren-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        panels.forEach((p) => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const panel = root.querySelector(`[data-noren-panel="${tab.dataset.norenTab}"]`);
        if (panel) panel.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsukiji-rope-temp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const tags = document.querySelectorAll('[data-rope-tag]');
    tags.forEach((tag) => {
      const head = tag.querySelector('[data-rope-head]');
      if (!head) return;
      head.addEventListener('click', () => {
        const isOpen = tag.classList.contains('is-open');
        tags.forEach((t) => t.classList.remove('is-open'));
        if (!isOpen) tag.classList.add('is-open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
